import http from 'src/app/http';
import environment from 'src/app/environment';


const loginRequest = (body) => http.post('/zaloguj', { ...body });

const loginFacebook = (params) =>
  `${environment.facebookAuthenticationDomain}/zaloguj-facebook?provider=Facebook${params}`;

export default {
  loginRequest,
  loginFacebook
};
